import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule, MatSelect } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { EgTableComponent } from '../../shared/components/eg-table/eg-table.component';
import { ToastrService } from 'ngx-toastr';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CaseManagementService } from '../../service/case-management.service';
import { catchError, forkJoin, map, of } from 'rxjs';
import { MatIconModule } from '@angular/material/icon'; // Import MatIconModule
import { SharedCaseManagementService } from '../../shared/services/shared-case-management.service';
import { SharedApplicantService } from '../../shared/services/shared-applicant.service';
import { DateTime } from 'luxon';
import { LuxonDateAdapter, MAT_LUXON_DATE_ADAPTER_OPTIONS, MAT_LUXON_DATE_FORMATS } from '@angular/material-luxon-adapter';
import { ApplicantService } from '../../service/applicant.service';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';
import { UserManagementService } from '../../service/user-management.service';
import { UserService } from '../../shared/services/user.service';
const DETERMINATION_LETTER_SENT = 'determination letter sent';
const DETERMINATION_APPROVED = 'determination approved';
const APPROVAL_LETTER_SENT = 'approval letter sent';

@Component({
  selector: 'app-case-list',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    EgTableComponent,
    MatButtonModule,
    MatInputModule,
    MatTooltipModule,
    MatIconModule,
    MatTabsModule,
    MatBadgeModule
  ],
  providers: [
  { provide: DateAdapter, useClass: LuxonDateAdapter, deps: [MAT_DATE_LOCALE, MAT_LUXON_DATE_ADAPTER_OPTIONS] },
  { provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS },
  { provide: MAT_LUXON_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
  ],
  templateUrl: './case-list.component.html',
  styleUrls: ['./case-list.component.scss'],
})
export class CaseListComponent implements OnInit {
  @ViewChild(MatSelect) assigneeSelect!: MatSelect;
  @ViewChild('timeRemainingDropdown') timeRemainingSelect!: MatSelect;
  @ViewChild('assigneeSearchInput') assigneeSearchInput!: ElementRef<HTMLInputElement>;

  assigneeSearchCtrl = new FormControl('');
  assigneeOptions1: any[] = []; // Initialize as an empty array
  filteredAssigneeOptions = [...this.assigneeOptions1]; // initially same as assigneeOptions
  isSearchingAssignees: boolean = false;
  allCompletionStatusSelected = false;
  allAssigneesSelected = false;
  isDropdownOpen = false;
  selectedDateRangeText: string | null = null; // Variable to store the formatted date range
  isLoading = true; // Variable to handle loading state
  agencyId = '';
  userRole: string | null = '';
  isEligibilityAutoDetermined: boolean = false;
  caseList: any[] = []; // Static data for now
  historyList: any = [];
  displayedColumns = [
    { key: 'timeConsumedInPercentage', label: 'Time Remaining' },
    { key: 'applicantName', label: 'Applicant' },
    { key: 'lastUpdatedDate', label: 'Last Updated' },
    { key: 'caseCompletionStatus', label: 'Completion Status' },
    { key: 'assignee', label: 'Assignee' },
    { key: 'actionsCases', label: 'Actions' },
  ];
  
  cols: any = ['timeConsumedInPercentage', 'applicantName', 'lastUpdatedDate', 'caseCompletionStatus', 'assignee', 'actionsCases'];

  approvedDisplayColumns = [
    { key: 'applicantName', label: 'Applicant' },
    { key: 'lastUpdatedDate', label: 'Last Updated' },
    { key: 'caseCompletionStatus', label: 'Completion Status' },
    { key: 'assignee', label: 'Assignee' },
    { key: 'actionsCases', label: 'Actions' },
    { key: 'renewal', label: 'Renewal' }
  ];
  approvedCols: any = ['applicantName', 'lastUpdatedDate', 'caseCompletionStatus', 'assignee', 'actionsCases', 'renewal'];
 
  selectedFile: File | null = null;
  selectedFileName: string = 'Choose file';
 
  // Multiselect dropdown options for Completion Status
  completionStatusOptions: any[] = [];
  groupedCompletionStatusOptions: { statusGroup: string; statuses: any[] }[] = []; // Grouped statuses
 
  // Multiselect dropdown options for Assignee
  assigneeOptions : any[] = [];
 
  // Dropdown options for Min Time Remaining
  minTimeOptions: string[] = ['<0 day', ...Array.from({ length: 22 }, (_, i) => i + ' days')];
  maxTimeOptions: string[] = [...Array.from({ length: 22 }, (_, i) => i + ' days')];
  filterForm: FormGroup;
  selectedAssigneesLength: number = 0;
  pageNo = 0;
  limit = 10;
  start = 0;  // Start index of the current page
  end = 10;   // End index of the current page
  totalElements = 0;  // Total number of elements in all pages
  pageSize = 10;
  pageIndex = 0;
  minTime: string = 'No Min';
  maxTime: string = 'No Max';
  tabNames = ['Active', 'Approved', 'Denied'];
  currentTabStatusType: string = 'ACTIVE';
  activeCount: number = 0;
  approvedCount: number = 0;
  deniedCount: number = 0;

  constructor(private readonly toastr: ToastrService, private readonly fb: FormBuilder, private readonly router: Router, private readonly caseManagementService: CaseManagementService,
    private readonly sharedCaseManagementService: SharedCaseManagementService, private readonly applicantService: ApplicantService, private readonly sharedApplicantService: SharedApplicantService,
    private readonly userManagementService: UserManagementService, private readonly userService: UserService
  ) {
    this.filterForm = this.fb.group({
      searchText: [''],
      timeRemaining: [[]],
      minRemainingDays: [''],
      maxRemainingDays: [''],
      lastUpdated: [[]],
      completionStatus: [[]],
      assignees: [[]],
      dateRange: this.fb.group({
        start: [null],
        end: [null],
      }),
    });
  }
  workflowStatuses = [];
  workflowStatusesCommaSeparated = '';
  
  fetchData(page: any, limit: any, statusType: string) {
    console.log(this.selectedAssigneeCommaSeparated);
    this.isLoading = true;
    const keyword = this.filterForm.get('searchText')?.value || '';
    const statuses = this.filterForm.get('completionStatus')?.value?.join(',') || '';
    let startDate = this.filterForm.get('dateRange.start')?.value || '';
    let endDate = this.filterForm.get('dateRange.end')?.value || '';
    const rawMinTime = this.filterForm.get('minRemainingDays')?.value || '';
    const rawMaxTime = this.filterForm.get('maxRemainingDays')?.value || '';
    let assignee = this.filterForm.get('assignee')?.value || '';
   
    startDate = startDate
      ? (startDate instanceof Date
          ? DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
          : DateTime.fromISO(startDate).toFormat('yyyy-MM-dd'))
      : '';
    endDate = endDate
      ? (endDate instanceof Date
          ? DateTime.fromJSDate(endDate).toFormat('yyyy-MM-dd')
          : DateTime.fromISO(endDate).toFormat('yyyy-MM-dd'))
      : '';
    // Handle "<1 day" case for minRemainingDays and maxRemainingDays
  let selectedMinRemainingDays =
    rawMinTime === '<0 day'
      ? -1
      : rawMinTime === 'No Min'
      ? ''
      : rawMinTime
      ? parseInt(rawMinTime)
      : '';
  
  let selectedMaxRemainingDays =
    rawMaxTime === 'No Max'
      ? ''
      : rawMaxTime
      ? parseInt(rawMaxTime)
      : '';

    // Handle the condition where selectedMaxRemainingDays has a value other than "No Max" and selectedMinRemainingDays is empty
    if (selectedMinRemainingDays !== '' && selectedMaxRemainingDays === '') {
      selectedMaxRemainingDays = 21;
    }
    if (selectedMaxRemainingDays !== '' && selectedMinRemainingDays === '') {
      selectedMinRemainingDays = -1;
    }
    // Sequential: getWorkflowStatus first, then getAllCases and getAssigneeDropdownData in parallel
    this.caseManagementService.getWorkflowStatus(statusType).pipe(
      catchError((error) => of({ error }))
    ).subscribe((workflowStatusDetails: any) => {
      if (workflowStatusDetails && !workflowStatusDetails.error) {
        this.workflowStatuses = workflowStatusDetails.map((status: any) => status.id);
        console.log(this.workflowStatuses);
        // Group statuses by statusGroup
        const groupedStatuses = new Map<string, any[]>();
        Array.isArray(workflowStatusDetails) && workflowStatusDetails.forEach((status: any) => {
          if (!groupedStatuses.has(status.statusGroup)) {
            groupedStatuses.set(status.statusGroup, []);
          }
          groupedStatuses.get(status.statusGroup)?.push(status);
        });
        // Convert the Map to an array for easier rendering in the template
        this.groupedCompletionStatusOptions = Array.from(groupedStatuses.entries()).map(([statusGroup, statuses]) => ({
          statusGroup,
          statuses
        }));
        this.completionStatusOptions = Array.isArray(workflowStatusDetails) ? workflowStatusDetails.map((status: any) => ({
          id: status.id,
          status: status.status
        })) : [];
        let assignee1 = '';
        
        if(this.isTabChanged) {
          this.workflowStatusesCommaSeparated = this.workflowStatuses.join(',');
          this.clearFilters();
          this.isTabChanged = false;
        }
        else {
          this.workflowStatusesCommaSeparated = statuses== '' ? this.workflowStatuses.join(',') : statuses;
        }
        assignee1 = this.selectedAssigneeCommaSeparated;
        
        // Now call getAllCases and getAssigneeDropdownData in parallel
        forkJoin([
          this.caseManagementService.getAllCases(
            this.agencyId,
            keyword,
            this.workflowStatusesCommaSeparated,
            startDate,
            endDate,
            selectedMinRemainingDays.toString(),
            selectedMaxRemainingDays.toString(),
            page.toString(),
            limit.toString(),
            assignee1
          ),
          this.caseManagementService.getAssigneeDropdownData('ADMIN,CASE_MANAGER')
        ]).pipe(
          map(([cases, assigneeDetails]) => {
            return { cases, assigneeDetails };
          }),
          catchError((error) => of({ error }))
        ).subscribe((data) => {
          // Defensive checks for error property before accessing data.cases
          if (data && !('error' in data) && data.cases) {
            if (data.cases && typeof data.cases === 'object' && 'counts' in data.cases) {
              console.log((data.cases as any).counts);

              this.activeCount = (data.cases as any).counts.activeCount || 0;
              this.approvedCount = (data.cases as any).counts.approvedCount || 0;
              this.deniedCount = (data.cases as any).counts.deniedCount || 0;
            }
            // If data.cases.cases exists, use it; otherwise, fallback to data.cases
            const casesArray = (data.cases as any)?.cases ? (data.cases as any).cases : data.cases;
            if (casesArray) {
              // If casesArray has a 'content' property, use it; otherwise, use as array
              const caseListData = Array.isArray(casesArray) ? casesArray : casesArray.content || casesArray;
              this.caseList = this.mapApplications(caseListData);
              this.start = 0;
              this.end = casesArray.numberOfElements || 0;
              this.totalElements = casesArray.totalElements || 0;
            } else {
              this.caseList = [];
              this.start = 0;
              this.end = 0;
              this.totalElements = 0;
            }
          } else {
            this.caseList = [];
            this.start = 0;
            this.end = 0;
            this.totalElements = 0;
          }
          if (data && 'assigneeDetails' in data) {
            this.assigneeOptions = Array.isArray((data as any).assigneeDetails)
              ? (data as any).assigneeDetails.map((assignee: any) => ({
                  name: `${assignee.firstName} ${assignee.lastName}`,
                  userId: assignee.userId,
                }))
              : [];
            this.filteredAssigneeOptions = [...this.assigneeOptions];
          } else if (data && 'error' in data) {
            console.error('Error fetching assignee details:', data.error);
            this.toastr.error('Failed to fetch assignee details.');
            this.userManagementService.redirectToLogin(data.error, '');
          }
          this.isLoading = false;
        }, (error) => {
          console.error('Error fetching data:', error);
          this.isLoading = false;
        });
      } else {
        // Error in getWorkflowStatus
        console.error('Error fetching workflow status:', workflowStatusDetails.error);
        this.toastr.error('Failed to fetch workflow status.');
        this.userManagementService.redirectToLogin(workflowStatusDetails.error, '');
        this.isLoading = false;
      }
    });
  }
  fetchCases(page: any, limit: any, keyword: string = '') {
    this.isLoading = true;
    // Ensure keyword is not null or undefined
    keyword = keyword || '';
    const statuses = this.filterForm.get('completionStatus')?.value?.join(',') || '';
    let startDate = this.filterForm.get('dateRange.start')?.value || '';
    let endDate = this.filterForm.get('dateRange.end')?.value || '';
    const rawMinTime = this.filterForm.get('minRemainingDays')?.value;
    const rawMaxTime = this.filterForm.get('maxRemainingDays')?.value;
    const assignee = this.filterForm.get('assignees')?.value || '';

    if(statuses == '') {
      this.workflowStatusesCommaSeparated = this.workflowStatuses.join(',');
    }
    else {
      this.workflowStatusesCommaSeparated = statuses;
    }
    
    startDate = startDate
      ? (startDate instanceof Date
          ? DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
          : DateTime.fromISO(startDate).toFormat('yyyy-MM-dd'))
      : '';
    endDate = endDate
      ? (endDate instanceof Date
          ? DateTime.fromJSDate(endDate).toFormat('yyyy-MM-dd')
          : DateTime.fromISO(endDate).toFormat('yyyy-MM-dd'))
      : '';
    // Handle "<1 day" case for minRemainingDays and maxRemainingDays
  let selectedMinRemainingDays =
    rawMinTime === '<0 day'
      ? -1
      : rawMinTime === 'No Min'
      ? ''
      : rawMinTime
      ? parseInt(rawMinTime)
      : '';
  
  let selectedMaxRemainingDays =
    rawMaxTime === 'No Max'
      ? ''
      : rawMaxTime
      ? parseInt(rawMaxTime)
      : '';

  // Handle the condition where selectedMaxRemainingDays has a value other than "No Max" and selectedMinRemainingDays is empty
  if (selectedMinRemainingDays !== '' && selectedMaxRemainingDays === '') {
    selectedMaxRemainingDays = 21;
  }
  if (selectedMaxRemainingDays !== '' && selectedMinRemainingDays === '') {
    selectedMinRemainingDays = -1;
  }
 // Call the service
  this.caseManagementService
    .getAllCases(
      this.agencyId,
      keyword,
      this.workflowStatusesCommaSeparated,
      startDate,
      endDate,
      selectedMinRemainingDays.toString(),
      selectedMaxRemainingDays.toString(),
      page.toString(),
      limit.toString(),
      assignee
      )
      .subscribe({
      next: (response: any) => {
        if (response?.cases && typeof response.cases === 'object') {
          // Update badge counts if present
          if ('counts' in response.cases) {
            this.activeCount = response.cases.counts.activeCount || 0;
            this.approvedCount = response.cases.counts.approvedCount || 0;
            this.deniedCount = response.cases.counts.deniedCount || 0;
          }
          // If response.cases.cases exists, use it; otherwise, fallback to response.cases
          const casesArray = (response.cases as any)?.cases ? (response.cases as any).cases : response.cases;
          if (casesArray) {
            // If casesArray has a 'content' property, use it; otherwise, use as array
            const caseListData = Array.isArray(casesArray) ? casesArray : casesArray.content || casesArray;
            this.caseList = this.mapApplications(caseListData);
            this.start = 0;
            this.end = casesArray.numberOfElements || 0;
            this.totalElements = casesArray.totalElements || 0;
            this.isLoading = false;
            return;
          }
        }
        // If no valid cases found
        this.toastr.error('No cases found');
        this.isLoading = false;
        this.caseList = [];
      },
      error: (error: any) => {
        this.toastr.error('Failed to fetch cases.');
        console.error('Failed to fetch cases:', error);
        this.userManagementService.redirectToLogin(error,'');
        this.isLoading = false;
      }
    });
  }
  // Update mapping to match API fields
  private mapApplications(cases: any[]) {
    if(!cases) {
      return [];
    }
    console.log(cases);
    
    return cases?.map((caseItem) => {
      let workflowStatusValue = '';
      let renewalActions = false;
      let renewalRemainingDays = 0;
      if (caseItem?.workflowStatus) {
        workflowStatusValue = caseItem.workflowStatus;
        const status = caseItem.workflowStatus?.toLowerCase();
        renewalActions = (status.includes(DETERMINATION_LETTER_SENT) || status.includes(DETERMINATION_APPROVED) || status.includes(APPROVAL_LETTER_SENT));
      } else if (caseItem?.caseStatus) {
        workflowStatusValue = caseItem.caseStatus;
        const status = caseItem.caseStatus?.toLowerCase();
        renewalActions = (status.includes(DETERMINATION_LETTER_SENT) || status.includes(DETERMINATION_APPROVED) || status.includes(APPROVAL_LETTER_SENT));
      }
      if(caseItem?.renewalRemainingDays){
        renewalRemainingDays = caseItem?.renewalRemainingDays.split(' ')[0];
      }
      return {
        caseId: caseItem.caseId,
        applicantId: caseItem.applicantId,
        applicantName: caseItem.fullName, // API uses 'fullName'
        lastUpdatedDate: caseItem.caseUpdatedTime? DateTime.fromISO(caseItem.caseUpdatedTime).toFormat('MM/dd/yyyy hh:mm a'): 'N/A',
        caseCompletionGroupStatus: caseItem?.caseStatusGroup,
        caseCompletionStatus: caseItem.caseStatus,
        caseStatusId: caseItem.caseStatusId,
        processId: caseItem.processId,
        assignee: caseItem.assignedToName || 'Unassigned',
        assigneeId: caseItem.assignedToId,
        applicationEditable: caseItem.applicationEditable,
        caseAdminAllowed: caseItem.caseAdminAllowed,
        workflowStatus: workflowStatusValue,
        timeRemaining: caseItem.timeRemaining || 'N/A',
        timeConsumedInPercentage: caseItem.timeConsumedInPercentage || 0,
        downloadDeterminationLetter: caseItem.caseStatus?.toLowerCase() === 'determination letter sent' || caseItem.caseStatus?.toLowerCase() === 'determination approved' || caseItem.caseStatus?.toLowerCase() === 'determination denied' || caseItem.caseStatus?.toLowerCase() === 'approval letter sent' || caseItem.caseStatus?.toLowerCase() === 'denial letter sent',
        renewal : renewalActions ? renewalRemainingDays : 0,
        // renewal: caseItem?.showRenewalButton ? renewalRemainingDays : 0,   use this after getting showRenewalButton from API
        highlightPrintRenewalLetter: caseItem?.highlightPrintRenewalLetter || false,
        renewalLetterPrinted: caseItem?.renewalLetterPrinted || false,
        parentApplicationId: caseItem?.parentApplicationId,
      };
    });
  }
 
  // Getter for dateRange FormGroup
  get dateRange(): FormGroup {
    return this.filterForm.get('dateRange') as FormGroup;
  }
  selectedAssigneeCommaSeparated: string = '';

  ngOnInit(): void {
     // Initialize filteredAssigneeOptions with all assigneeOptions
    this.filteredAssigneeOptions = [...this.assigneeOptions];

    // Subscribe to search input changes
    this.assigneeSearchCtrl.valueChanges.subscribe(searchText => {
      const lower = searchText?.toLowerCase() || '';
      this.isSearchingAssignees = !!lower;
      this.filteredAssigneeOptions = this.assigneeOptions?.filter(
        assignee => assignee.name.toLowerCase().includes(lower)
      );
    });

    this.sharedApplicantService.userRole$.subscribe((data) => {
      this.userRole = data;
    });
    this.historyList = [];
    this.agencyId = sessionStorage.getItem('agencyId') || '';
    this.isLoading = true;
    this.fetchData(0, 10,'ACTIVE');
      // Add value change listeners
    this.filterForm.get('completionStatus')?.valueChanges.subscribe(value => {
      this.allCompletionStatusSelected = value?.length === this.completionStatusOptions.length;
    });

  // Subscribe to assignees value changes to update "Select All" checkbox
  this.filterForm.get('assignees')?.valueChanges.subscribe(selectedIds => {
    const allAssigneeIds = this.assigneeOptions.map(option => option.userId);
    this.allAssigneesSelected = Array.isArray(selectedIds) && selectedIds.length > 0 && allAssigneeIds.every(id => selectedIds.includes(id));
    this.selectedAssigneeCommaSeparated = this.filterForm.get('assignees')?.value?.join(',') || '';
  });
     
  }

  clearAssigneeSearch() {
    this.assigneeSearchCtrl.setValue('');
    this.isSearchingAssignees = false;
    this.filteredAssigneeOptions = [...this.assigneeOptions];
  }
 
  toggleSelectAll(controlName: 'completionStatus' | 'assignees', checked: boolean): void {
    const control = this.filterForm.get(controlName);

    if (controlName === 'completionStatus') {
      // Flatten all statuses from groupedCompletionStatusOptions
      const allStatusIds = this.groupedCompletionStatusOptions.flatMap(group =>
        group.statuses.map(status => status.id)
      );

      if (checked) {
        control?.setValue([...allStatusIds]); // Select all statuses
      } else {
        control?.setValue([]); // Deselect all statuses
      }

      this.allCompletionStatusSelected = checked;
    } else if (controlName === 'assignees') {
      const allAssigneeIds = this.assigneeOptions.map(option => option.userId);

      if (checked) {
        control?.setValue([...allAssigneeIds]); // Select all assignees
      } else {
        control?.setValue([]); // Deselect all assignees
      }

      this.allAssigneesSelected = checked;
    }
  }

  onOptionChange(controlName: 'completionStatus' | 'assignees'): void {
    const control = this.filterForm.get(controlName);

    if (controlName === 'completionStatus') {
      const allStatusIds = this.groupedCompletionStatusOptions.flatMap(group =>
        group.statuses.map(status => status.id)
      );

      const selectedStatusIds = control?.value || [];
      this.allCompletionStatusSelected = allStatusIds.every(id => selectedStatusIds.includes(id));
    }
  }
 
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
 
  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      this.selectedFileName = file.name;
    }
  }
 // check this with Shamroz
  uploadFile() {
    if (this.selectedFile) {
      // Implement the file upload logic here
      // Reset the file input after upload
      this.clearFile();
    }
  }
 
  clearFile() {
    this.selectedFile = null;
    this.selectedFileName = 'Choose file';
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
 
  toggleOption(controlName: string, option: string, checked: boolean) {
    const controlValue = this.filterForm.get(controlName)?.value;
    if (checked) {
      controlValue.push(option);
    } else {
      const index = controlValue.indexOf(option);
      if (index !== -1) {
        controlValue.splice(index, 1);
      }
    }
    this.filterForm.get(controlName)?.setValue(controlValue);
  }
 
  applySelection(event?: Event): void {
    const {
      selectedSearchText,
      rawMinTime,
      rawMaxTime,
      selectedAssignees,
      selectedCompletionStatus,
      startDate,
      endDate
    } = this.getCurrentFilterValues();

    // Handle "<1 day" case for minRemainingDays
    const selectedMinRemainingDays = rawMinTime === '<0 day' ? -1 : rawMinTime ? parseInt(rawMinTime) : '';
    const selectedMaxRemainingDays = rawMaxTime ? parseInt(rawMaxTime) : '';

    // Check if no filter is selected
    const noFiltersSelected =
      !selectedSearchText &&
      !rawMinTime &&
      !rawMaxTime &&
      selectedAssignees.length === 0 &&
      selectedCompletionStatus.length === 0 &&
      !startDate &&
      !endDate;

    if (noFiltersSelected) {
      this.toastr.warning('Please select at least one filter before applying.');
      return;
    }
    
    if (selectedMinRemainingDays > selectedMaxRemainingDays) {
      this.toastr.error('Minimum time remaining value cannot be greater than Maximum time remaining value.');
      return;
    } else {
      this.fetchCases(this.pageNo,this.pageSize, selectedSearchText);
    }
  
  }

  // Apply the selected date range
  applyDateRange() {
    const { startDate, endDate } = this.getCurrentFilterValues();
 
    if (startDate && endDate) {
      this.selectedDateRangeText = startDate+' - ' + (endDate);
    } else {
      this.selectedDateRangeText = null; // Reset if no valid range is selected
    }
 
    this.isDropdownOpen = false; // Close the dropdown
  }
 
  // Clear the selected date range
  clearDateRange() {
    this.dateRange.reset(); // Reset the date range controls
    this.selectedDateRangeText = null; // Clear the displayed text
  }
 
  getProgressBarWidth(daysRemaining: number): string {
    if (daysRemaining < 0) {
      return '100%';
    }
    const percentage = ((21 - daysRemaining) / 21) * 100;
    return `${percentage}%`;
  }
 
  viewCase(event: any) {
    if(event.action == 'view') {
      this.sharedCaseManagementService.changeCase(event.element);
      this.sharedCaseManagementService.changeCaseView('view');
      this.router.navigate(['/case-detail'], {
        queryParams: { id: event.element.caseId },
        state: { 'caseView': 'view' }
      });
    }
    else if(event.action == 'history') {
      this.caseManagementService.getHistoryByCaseId(event.element.caseId).subscribe((response: any) => {
        this.historyList = response;
        this.historyList = Array.isArray(response) ? response.map((history: any) => ({
          statusChanged: history?.description,
          notes: history?.remark,
          updatedDate: history?.updatedDate? DateTime.fromISO(history.updatedDate).toFormat('MM/dd/yyyy hh:mm a'): 'N/A', 
          user: history?.remarkBy,
        })) : [];
      });
    }
    else if (event.action === 'download') {
    const applicantId = event.element.applicantId;
    const applicationId = event.element.caseId;
    if (applicantId && applicationId) {
      this.downloadDeterminationLetter(applicantId, applicationId);
    } else {
      this.toastr.error('Applicant or Application ID missing.');
    }
    }
  }

  downloadDeterminationLetter(applicantId: number, applicationId: number) {
  this.applicantService.downloadDeterminationLetter(applicantId, applicationId).subscribe({
    next: (response: Blob) => {
      const fileURL = window.URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = applicationId + '-TAF Letter.docx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(fileURL);
      this.toastr.success('Determination letter download started ...', '', { timeOut: 1000 });
    },
    error: (error) => {
      this.toastr.error('Could not fetch determination letter. Please try again later.', '', { timeOut: 1000 });
      this.userManagementService.redirectToLogin(error,'');
    }
    });
  }
 
  closeInnerDropdown() {
    this.isDropdownOpen = false;
  }
 
  onSearchInput() {
    // Logic to handle search input changes
  }
 
  clearSearch(): void {
    this.filterForm.get('searchText')?.setValue('');
    this.fetchData(0, 10, this.currentTabStatusType);
  }
 
  getPaginatorData(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.pageNo = event.pageIndex;
    this.fetchData(event.pageIndex, event.pageSize, this.currentTabStatusType);
  }
 
  getCompletionStatusTooltip(): string {
    const selectedIds = this.filterForm.get('completionStatus')?.value || [];
    const selectedStatuses = this.completionStatusOptions
      .filter(option => selectedIds.includes(option.id))
      .map(option => option.status);
    return selectedStatuses.length > 0 ? selectedStatuses.join(', ') : ''; // Return an empty string if no options are selected
  }
  getAssigneeTooltip(): string {
    const selectedIds = this.filterForm.get('assignees')?.value || [];
    const selectedStatuses = this.assigneeOptions
      .filter(option => selectedIds.includes(option.userId))
      .map(option => option.name);
    return selectedStatuses.length > 0 ? selectedStatuses.join(', ') : ''; // Return an empty string if no options are selected
  }
  clearFilters() {
    const {
      selectedSearchText,
      rawMinTime,
      rawMaxTime,
      selectedAssignees,
      selectedCompletionStatus,
      startDate,
      endDate
    } = this.getCurrentFilterValues();

    const noFiltersSelected =
      !selectedSearchText &&
      !rawMinTime &&
      !rawMaxTime &&
      selectedAssignees.length === 0 &&
      selectedCompletionStatus.length === 0 &&
      !startDate &&
      !endDate;

    if (noFiltersSelected && !this.isTabChanged) {
      this.toastr.warning('No filters selected');
      return;
    }

    this.filterForm.reset();
    this.selectedDateRangeText = null; // Clear the displayed text
    this.allCompletionStatusSelected = false;
    this.allAssigneesSelected = false;
    this.isLoading = true;
    this.getPaginatorData({pageIndex: 0, pageSize: 10});
  }
  closeAssigneeDropdown(event: Event): void {
    event.stopPropagation();
    this.assigneeSelect.close();
  }
  closeTimeRemainingDropdown(event: Event): void {
    event.stopPropagation(); // Prevent the dropdown from closing automatically
    this.timeRemainingSelect.close(); // Close the dropdown programmatically
  }
  focusAssigneeSearch() {
    setTimeout(() => {
      this.assigneeSearchInput?.nativeElement.focus();
    }, 0);
  }

  private getCurrentFilterValues() {
    const selectedSearchText = this.filterForm.get('searchText')?.value || '';
    const rawMinTime = this.filterForm.get('minRemainingDays')?.value;
    const rawMaxTime = this.filterForm.get('maxRemainingDays')?.value;
    const selectedAssignees = this.filterForm.get('assignees')?.value || [];
    const selectedCompletionStatus = this.filterForm.get('completionStatus')?.value || [];
    const startDate = this.dateRange.get('start')?.value;
    const endDate = this.dateRange.get('end')?.value;
    return {
      selectedSearchText,
      rawMinTime,
      rawMaxTime,
      selectedAssignees,
      selectedCompletionStatus,
      startDate,
      endDate
    };
  }
  selectedTabIndex = 0;
  isTabChanged = false;
  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    let statuses: any = [];
    console.log('Tab changed to: ' + tabChangeEvent.index);
    this.selectedTabIndex = tabChangeEvent.index;
    this.isLoading = true;
    this.isTabChanged = true;
    if(tabChangeEvent.index === 0) {
      this.currentTabStatusType = 'ACTIVE';
      this.getPaginatorData({pageIndex: 0, pageSize: 10});
    }
    else if(tabChangeEvent.index === 1) {
      this.currentTabStatusType = 'APPROVED';
      this.getPaginatorData({pageIndex: 0, pageSize: 10});
    }
    else if(tabChangeEvent.index === 2) {
      this.currentTabStatusType = 'DENIED';
      this.getPaginatorData({pageIndex: 0, pageSize: 10});
    }
  }
  onRenewalClicked(element: any) {
    this.isLoading = true;
    this.applicantService.checkForRenewalParentApplication(element.caseId).subscribe({
      next: (response: any) => {
        console.log(response);
        this.isLoading = false;
        if(!response) {
          this.sharedApplicantService.changeApplicantId(element.applicantId);
          this.router.navigate(['/application-form'], {
            queryParams: { id: element.caseId },
          });
          this.userService.setParentApplicationId(element.caseId);
        }
        if(response?.applicationId) {
          this.toastr.info('Renewal application already exists for this application.', '', { timeOut: 3000 });
          /* this.sharedApplicantService.changeApplicantId(this.applicant.applicantId);
          this.router.navigate(['/application-form'], {
            queryParams: { id: response.applicationId },
          }); */
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Error checking for renewal parent application:', error);
      }
    });
  }
  onPrintRenewalLetter(element: any) {
    if(element) {
      this.applicantService.downloadRecertificationLetter(element.caseId).subscribe({
        next: (response: Blob) => {
        const fileURL = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = element.caseId + '-Recertification Letter.docx';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(fileURL);
        this.toastr.success(`Recertification letter download started ...`, '', {
          timeOut: 1000,
        });
      },
        error: (error) => {
          console.error('Error viewing document:', error);
          this.toastr.error('Could not view the document', '', { timeOut: 1000 });
        }
      });
    }
  }
}